import React, { Component } from 'react';
import { FormGroup, Input, Button, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import { IconCorreo, ArrowRight } from '../../assets/icons/svgIcon';
import { solicitarNuevoCodigo, validarCodigoAcceso } from '../../store/sagas/authApi';
import FormFeedback from 'reactstrap/lib/FormFeedback';
import { notificacion } from '../../utilitarios/util';
import {SvgAssets} from '../../assets/icons/iconSvg';
import c from '../../constants/Colors';
import Spinner from "../reusable/Loader";

export class VerificarCorreo extends Component {
  static displayName = VerificarCorreo.name;
  constructor(props) {
    super(props);

    this.TextInput1 = React.createRef();
    this.TextInput2 = React.createRef();
    this.TextInput3 = React.createRef();
    this.TextInput4 = React.createRef();
    this.state = {
      loading: false,
      email: null,
      errorValidacion: null,
      input1: '',
      input2: '',
      input3: '',
      input4: '',
      alertTitulo: "",
      alertMensaje: ""
    };
  }

  load = async () => {
    this.setState({
      loading: false,
      email: null,
      errorValidacion: null,
      input1: '',
      input2: '',
      input3: '',
      input4: ''
    });
  }

  checkParams() {
    const { state } = this.props.location;
    this.setState({
      email: state.email,
      errorValidacion: state.errorValidacion
    });
    console.log("checkParams==>", state.email);
  }
  ActivarContrania = () => {
    var verificacion = (this.state.input1 ?? "") + (this.state.input2 ?? "") + (this.state.input3 ?? "") + (this.state.input4 ?? "")

    this.setState({ errorValidacion: null });
    if (verificacion == null || verificacion == "" || verificacion.length < 4) {
      this.setState({ errorValidacion: "Ingrese el código de verificación" });
    } else {
      this.postValidarCodigoAcceso(verificacion, this.state.email);
    }
  }
  setInput1 = (value, nextComponent) => {
    this.setState({ input1: value, errorValidacion: null })
    if (/^\d$/.test(value)) nextComponent.focus();
  }

  setInput2 = (value, nextComponent, prevComponent) => {
    this.setState({ input2: value, errorValidacion: null })
    if (/^\d$/.test(value)) nextComponent.focus();
    if (value == "") prevComponent.focus();
  }

  setInput3 = (value, nextComponent, prevComponent) => {
    this.setState({ input3: value, errorValidacion: null })
    if (/^\d$/.test(value)) nextComponent.focus();
    if (value == "") prevComponent.focus();
  }

  setInput4 = (value, prevComponent) => {
    this.setState({ input4: value, errorValidacion: null })
    if (value == "") prevComponent.focus();
  }

  componentDidMount() {
    this.load();
    this.checkParams();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.state !== this.props.location.state) {
      this.checkParams();
    }
  }

  render() {
    const { input1, input2, input3, input4, loading, email, errorValidacion } = this.state;
    return (
      <div id="mhw">
        <Spinner visible={loading} />
        <Container className="py-5">
          <button className="btn-back mobile" 
            onClick={() => this.props.history.push('/')}
          >
            <SvgAssets icon="icon-back" fill="#fff" />
          </button>
          <h4 className="text-center title-2 morado desktop"><SvgAssets className="mr-2" icon="icon-lock" fill={c.morado}/>Verifica tu correo</h4>
          <div className="card">
            <h4 className="text-center title-2 morado mobile"><IconCorreo className='icon-block' />Verifica <br className="mobile" /> tu correo</h4>
            <p className="paragraph-1 text-center light morado mb-0">Por favor, ingresa el código que te hemos enviado a <strong>{email}</strong></p>
            <FormGroup className="group-cod">
              <div className="inputs-cod">
                <input className="cod morado" placeholder="0" maxLength={1} value={input1.replace(/[^0-9]/g, "")} onChange={(e) => { let input1 = e.currentTarget.value; this.setInput1(input1, this.TextInput2) }} ref={(input) => { this.TextInput1 = input; }} />
                <input className="cod morado" placeholder="0" maxLength={1} value={input2.replace(/[^0-9]/g, "")} onChange={(e) => { let input2 = e.currentTarget.value; this.setInput2(input2, this.TextInput3, this.TextInput1) }} ref={(input) => { this.TextInput2 = input; }} />
                <input className="cod morado" placeholder="0" maxLength={1} value={input3.replace(/[^0-9]/g, "")} onChange={(e) => { let input3 = e.currentTarget.value; this.setInput3(input3, this.TextInput4, this.TextInput2) }} ref={(input) => { this.TextInput3 = input; }} />
                <input className="cod morado" placeholder="0" maxLength={1} value={input4.replace(/[^0-9]/g, "")} onChange={(e) => { let input4 = e.currentTarget.value; this.setInput4(input4, this.TextInput3) }} ref={(input) => { this.TextInput4 = input; }} />
              </div>
              {errorValidacion ? <FormFeedback>{errorValidacion}</FormFeedback> : null}
            </FormGroup>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <a className="link-u d-block text-center" href="#" onClick={(e) => { e.preventDefault(); this.postSolicitarNuevoCodigo() }} >Reenviar código</a>
            </div>
            <div className="text-center mt-5">
              {/* <Link to="/ingresar-contrasenia" style={{textDecoration:'none'}}> */}
              <button
                className={`btn-block red${(input1 != "" && input2 != "" && input3 != "" && input4 != "" ? "" : " disabled")}`}
                type="button"
                disabled={!(input1 != "" && input2 != "" && input3 != "" && input4 != "")}
                onClick={() => this.ActivarContrania()}
              >
                siguiente<ArrowRight className='svg-right' />
              </button>
              {/* </Link> */}
            </div>
          </div>
        </Container >
      </div>
    );
  }

  postSolicitarNuevoCodigo = async () => {
    let CorreoElectronico = this.state.email;
    this.setState({ loading: true });
    solicitarNuevoCodigo(CorreoElectronico)
      .then(result => {
        debugger;
        this.setState({ loading: false });
        if (result.mo.type == "success") {
          this.setState({ loading: false, errorValidacion: "Su código fue enviado al correo electrónico" });
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        //console.log("postLogin ", error);
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Login", error.message ?? null);
        });
      });
  }
  postValidarCodigoAcceso = async (CodigoVerificacion, CorreoElectronico) => {
    // let CorreoElectronico = this.state.email;
    this.setState({ loading: true });
    console.log("Parametro=====>", CorreoElectronico, CodigoVerificacion);
    validarCodigoAcceso(CorreoElectronico, CodigoVerificacion)
      .then(result => {
        this.setState({ loading: false });
        if (result.mo.type == "success") {
          this.props.history.push({
            pathname: '/ingresar-contrasenia',
            state: { email: this.state.email, codigoVerificacion: CodigoVerificacion }
          });
        } else {
          this.setState({ loading: false, errorValidacion: result.mo.listMessage.join(", ") });
        }
      }).catch((error) => {
        //console.log("postLogin ", error);
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Login", error.message ?? null);
        });
      });
  }
}
